import { usePhoneApi } from "../api/PhoneApiClient";
import { PhoneFrontendService } from "../services/PhoneFrontendService";

export const usePhoneService = (): PhoneFrontendService =>
  new PhoneFrontendService(usePhoneApi());
